import type { GridValueFormatterParams } from "@mui/x-data-grid";
import { UiDateTimeFormatter, formatDate } from "util/formaters";

type Params = {
    readonly pattern?: string;
};

const dateFormater = ({
    pattern = UiDateTimeFormatter.Default
}: Params = {}) => ({ value }: GridValueFormatterParams<string>) =>
    formatDate(value, { pattern });

export default dateFormater;
